import { sessionPrefix } from "./helpers";

export const adminUsersPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/admin/users`;
export const newAdminUserPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/admin/users/new`;
export const editAdminUserPath = (session: LightSessionInterface, user: UserRef) =>
  `${sessionPrefix(session)}/admin/users/${user.id}/edit`;
export const changePasswordPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/profile/password`;
export const profilePath = (session: LightSessionInterface) => `${sessionPrefix(session)}/profile`;
